import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseApiTemplateService} from '../../../shared/base-api-template-service.model';
import {Core2Config} from '../../../shared/core2Config';
import { JobDocLineLinkContainerModel } from '../../../../../../../models/aggregates/erp/delivery/job';
import { ApiVisa } from '../../../shared';


@Injectable({
  providedIn: 'root'
})
export class LoginDriverJobDocLineLinkService extends BaseApiTemplateService<JobDocLineLinkContainerModel> {
  readonly url = Core2Config.DOMAIN_TEST_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'del/job-docline-links/login-driver-ep';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_TEST_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'del/job-docline-links/login-driver-ep';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + 'del/job-docline-links/login-driver-ep';
    this.httpClient = http;
  }

  updateProofOfReceipt(jobDocLineLinkGuid: string, dto: Object, visa: ApiVisa) {
    let url = this.apiUrl + '/updateProofOfReceipt/' + jobDocLineLinkGuid;
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path + '/updateProofOfReceipt/' + jobDocLineLinkGuid;
    }
    return this.httpClient.put(url, dto, this.getHttpHeader(visa));
  }
}
